import { isUserLoggedIn } from "@/auth/utils";

export default [
    {
        path: "/settings",
        name: "settings",
        component: () => import("@/views/modules/settings/settings.vue"),
        meta: {
            contentClass: "module-settings",
            resource: "settings",
            action: "read",
        },
        beforeEnter: isUserLoggedIn,
    },
    /** SETTINGS / MY ACCOUNT **/
    {
        path: "/settings/account",
        name: "settings-account",
        component: () => import("@/views/modules/settings/account/account.vue"),
        meta: {
            navActiveLink: "settings",
            resource: "settings",
            action: "read",
        },
        beforeEnter: isUserLoggedIn,
    },
    /**
     * SETTINGS / USERS
     * Possession does not work with CASL, and users have a update and read action so we have to check for create in all cases to make sure only managers can visit
     * **/
    {
        path: "/settings/users",
        name: "settings-users",
        component: () => import("@/views/modules/settings/users/users.vue"),
        meta: {
            navActiveLink: "settings",
            resource: "users",
            action: "create",
        },
        beforeEnter: isUserLoggedIn,
    },
    {
        path: "/settings/users/add",
        name: "settings-users-add",
        component: () => import("@/views/modules/settings/users/usersAdd.vue"),
        meta: {
            navActiveLink: "settings",
            resource: "users",
            action: "create",
        },
        beforeEnter: isUserLoggedIn,
    },
    {
        path: "/settings/users/:id",
        name: "settings-users-edit",
        component: () => import("@/views/modules/settings/users/usersEdit.vue"),
        meta: {
            navActiveLink: "settings",
            resource: "users",
            action: "create",
        },
        beforeEnter: isUserLoggedIn,
    },
    /** SETTINGS / TEAMS **/
    {
        path: "/settings/teams",
        name: "settings-teams",
        component: () => import("@/views/modules/settings/teams/teams.vue"),
        meta: {
            navActiveLink: "settings",
            resource: "teams",
            action: "update",
        },
        beforeEnter: isUserLoggedIn,
    },
    {
        path: "/settings/teams/add",
        name: "settings-teams-add",
        component: () => import("@/views/modules/settings/teams/teamsAdd.vue"),
        meta: {
            navActiveLink: "settings",
            resource: "teams",
            action: "create",
        },
        beforeEnter: isUserLoggedIn,
    },
    {
        path: "/settings/teams/:id",
        name: "settings-teams-edit",
        component: () => import("@/views/modules/settings/teams/teamsEdit.vue"),
        meta: {
            navActiveLink: "settings",
            resource: "teams",
            action: "update",
        },
        beforeEnter: isUserLoggedIn,
    },
    /** SETTINGS / CHANNELS **/
    {
        path: "/settings/channels",
        name: "settings-channels",
        component: () => import("@/views/modules/settings/channels/channels.vue"),
        meta: {
            navActiveLink: "settings",
            resource: "channels",
            action: "update",
        },
        beforeEnter: isUserLoggedIn,
    },
    {
        path: "/settings/channels/:id",
        name: "settings-channels-edit",
        component: () => import("@/views/modules/settings/channels/channelsEdit.vue"),
        meta: {
            navActiveLink: "settings",
            resource: "channels",
            action: "update",
        },
        beforeEnter: isUserLoggedIn,
    },
    /** SETTINGS / TAGS **/
    {
        path: "/settings/tags",
        name: "settings-tags",
        component: () => import("@/views/modules/settings/tags/tags.vue"),
        meta: {
            navActiveLink: "settings",
            resource: "tags",
            action: "update",
        },
        beforeEnter: isUserLoggedIn,
    },
    /** SETTINGS / LABELS **/
    {
        path: "/settings/labels",
        name: "settings-labels",
        component: () => import("@/views/modules/settings/labels/labels.vue"),
        meta: {
            navActiveLink: "settings",
            resource: "labels",
            action: "update",
        },
        beforeEnter: isUserLoggedIn,
    },
    /** SETTINGS / SMART ROUTING **/
    {
        path: "/settings/smart-routing",
        name: "settings-smartrouting",
        component: () => import("@/views/modules/settings/smart-routing/smartRouting.vue"),
        meta: {
            navActiveLink: "settings",
            resource: "smart-routing",
            action: "read",
        },
        beforeEnter: isUserLoggedIn,
    },
    {
        path: "/settings/smart-routing/add",
        name: "settings-smartrouting-add",
        component: () => import("@/views/modules/settings/smart-routing/smartRoutingAdd.vue"),
        meta: {
            navActiveLink: "settings",
            resource: "smart-routing",
            action: "create",
        },
        beforeEnter: isUserLoggedIn,
    },
    {
        path: "/settings/smart-routing/:id",
        name: "settings-smartrouting-edit",
        component: () => import("@/views/modules/settings/smart-routing/smartRoutingEdit.vue"),
        meta: {
            navActiveLink: "settings",
            resource: "smart-routing",
            action: "update",
        },
        beforeEnter: isUserLoggedIn,
    },
    /** SETTINGS / IP WHITELISTING **/
    {
        path: "/settings/ip-whitelisting",
        name: "settings-ipwhitelisting",
        component: () => import("@/views/modules/settings/ip-whitelisting/ipWhitelisting.vue"),
        meta: {
            navActiveLink: "settings",
            resource: "whitelistedIps",
            action: "update",
        },
        beforeEnter: isUserLoggedIn,
    },
    {
        path: "/settings/ip-whitelisting/add",
        name: "settings-ipwhitelisting-add",
        component: () => import("@/views/modules/settings/ip-whitelisting/ipWhitelistingAdd.vue"),
        meta: {
            navActiveLink: "settings",
            resource: "whitelistedIps",
            action: "create",
        },
        beforeEnter: isUserLoggedIn,
    },
    {
        path: "/settings/ip-whitelisting/:id",
        name: "settings-ipwhitelisting-edit",
        component: () => import("@/views/modules/settings/ip-whitelisting/ipWhitelistingEdit.vue"),
        meta: {
            navActiveLink: "settings",
            resource: "whitelistedIps",
            action: "update",
        },
        beforeEnter: isUserLoggedIn,
    },
    {
        path: "/settings/whatsapp-templates",
        name: "settings-whatsapp-templates",
        component: () => import("@/views/modules/settings/whatsapp-templates/whatsAppTemplates.vue"),
        meta: {
            navActiveLink: "settings",
            resource: "messageTemplatesManager",
            action: "read",
        },
        beforeEnter: isUserLoggedIn,
    },
    {
        path: "/settings/whatsapp-templates/add",
        name: "settings-whatsapp-templates-add",
        component: () => import("@/views/modules/settings/whatsapp-templates/whatsAppTemplatesAdd.vue"),
        meta: {
            navActiveLink: "settings",
            resource: "messageTemplatesManager",
            action: "read",
        },
        beforeEnter: isUserLoggedIn,
    },
    {
        path: "/settings/whatsapp-templates/:id",
        name: "settings-whatsapp-templates-edit",
        component: () => import("@/views/modules/settings/whatsapp-templates/whatsAppTemplatesEdit.vue"),
        meta: {
            navActiveLink: "settings",
            resource: "messageTemplatesManager",
            action: "read",
        },
        beforeEnter: isUserLoggedIn,
    },
    {
        path: "/settings/system",
        name: "settings-system",
        component: () => import("@/views/modules/settings/system/system.vue"),
        meta: {
            navActiveLink: "settings",
            resource: "customerSettings",
            action: "update",
        },
        beforeEnter: isUserLoggedIn,
    },
    {
        path: "/settings/developers",
        name: "settings-developers",
        component: () => import("@/views/modules/settings/developers/developers.vue"),
        meta: {
            navActiveLink: "settings",
            resource: "developers",
            action: "read",
        },
        beforeEnter: isUserLoggedIn,
    },
];
